import { render, staticRenderFns } from "./error.vue?vue&type=template&id=d5ea9138&"
import script from "./error.vue?vue&type=script&lang=js&"
export * from "./error.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d5ea9138')) {
      api.createRecord('d5ea9138', component.options)
    } else {
      api.reload('d5ea9138', component.options)
    }
    module.hot.accept("./error.vue?vue&type=template&id=d5ea9138&", function () {
      api.rerender('d5ea9138', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "layouts/error.vue"
export default component.exports